import * as React from 'react';
import { ReactNode } from 'react';
import '../css/card.sass';
import Hat, { HatType } from './Hat';
import Shoe from './Shoe';
import style2object from '../utils/style-object';
import shouldFlipBG from '../utils/should-flip-bg';
import SelectableCard from './SelectableCard';
import LinkButtons, { LinkButtonType } from './LinkButtons';

interface CardProps {
  theme?: 'day' | 'night';
  children: ReactNode;
  hat?: HatType[];
  shoe?: ReactNode;
  style?: string;
  backgroundColor?: string;
  height?: string;
  width?: string;
  icon?: 'account' | 'billing' | 'hamburger';
  iconUrl?: string;
  selectable?: boolean;
  selected?: boolean;
  disabled?: boolean;
  onChange?: Function;
  title?: string;
  titleElement?: React.ReactNode;
  shadow?: boolean;
  links?: LinkButtonType[];
  selectableCardAriaLabel?: string;
  selectableCardId?: string;
  ariaLabelledByLabel?: string;
  isRoleButton?: boolean;
}

interface CardState {
  flipBg?: string;
  hover: boolean;
}

export default function Card(props: CardProps) {
  const { theme = 'day' } = props;
  const inputElParent = React.useRef(null);
  const [state, setState] = React.useState<CardState>({
    flipBg: '',
    hover: false
  });

  React.useEffect(() => {
    if (!state.flipBg && shouldFlipBG(inputElParent, theme)) {
      setState({
        ...state,
        flipBg: ' flipbg'
      });
    } else {
      setState({
        ...state,
        flipBg: ''
      });
    }
  }, []);

  if (props.selectable) return <SelectableCard {...props} />;

  const customStyle = props.style ? style2object(props.style) : {};
  if (props.backgroundColor) {
    customStyle.backgroundColor = props.backgroundColor;
  }
  if (props.height) {
    customStyle.height = props.height;
  }
  if (props.width) {
    customStyle.width = props.width;
  }
  let iconClassName: string | null = null;
  if (props.iconUrl) {
    iconClassName = 'custom';
  } else if (props.icon) {
    iconClassName = `${props.icon}`;
  }

  return (
    <>
      {props.hat &&
        props.hat.length > 0 &&
        props.hat[0] &&
        props.hat[0].message && <Hat hat={props.hat} theme={theme} />}
      <div
        ref={inputElParent}
        className={`card${state.flipBg} ${theme}${
          props.disabled ? ' disabled' : ''
        }${props.shadow ? ' shadow' : ''}`}
        style={customStyle}
      >
        {props.title ? <div className="title">{props.title}</div> : null}
        {props.titleElement}
        {iconClassName && (
          <div
            className={`card-icon ${iconClassName}`}
            style={
              props.iconUrl ? { backgroundImage: `url(${props.iconUrl})` } : {}
            }
          />
        )}

        {state.flipBg !== undefined && props.children}
        {props.links ? <LinkButtons linkButtons={props.links} /> : null}
      </div>
      {props.shoe && <Shoe>{props.shoe}</Shoe>}
    </>
  );
}
